import { AuthenticationService } from './../../../services/authentication/authentication.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { fuseAnimations } from '../../../../core/animations';
import { DivisionService } from '../../../services/divisions/division.service';
import { ShiftService } from '../../../services/shifts/shift.service';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from '../../../../../environments/environment';
import { SweetAlertService } from '../../../services/sweet-alert/sweet-alert.service';
import { Router } from '@angular/router';
import { CurriculumService } from '../../../services/curricula/curriculum.service';

@Component({
    selector: 'fuse-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    animations: fuseAnimations
})
export class FuseHomeComponent implements OnInit, OnDestroy {
    public divisions = [];
    public shifts = [];
    public curriculums = [];
    public divisionsGroup = [];
    public noDivisions = false;
    @BlockUI('tracker') blockUIList: NgBlockUI;



    public curriculumSelected = -1;
    public shiftSelected = -1;

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        this.blockUIList.start('Cargando datos...');
        Observable.combineLatest(
            this.divisionService.getAllCountStudents(this.authenticationService.getAuthData().SchoolYear.Id, this.authenticationService.getAuthData().Id),
            this.shiftService.getAll(),
            this.curriculumService.getAll()
        ).subscribe(([divisions, shifts, curriculums]) => {
            console.log(divisions);
            this.divisions = divisions;
            this.shifts = [];
            shifts.forEach(e => {
                let found = this.authenticationService.getAuthData().Shifts.find(s => s.Id === e.Id);
                if (found) {
                    this.shifts.push(e);
                }
            });


            this.curriculums = curriculums;
            this.curriculumSelected = this.curriculums[0].Id;
            console.log(divisions);
            console.log(shifts);
            console.log(curriculums);
            this.groupDivision();
            this.blockUIList.stop();
        });
    }

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                public curriculumService: CurriculumService,
                private router: Router,
                private sweetAlertService: SweetAlertService) {
    }

    public groupDivision() {
        this.divisionsGroup = [];
        this.divisions.forEach(e => {
            let found = this.divisionsGroup.find(d => d.CourseYearId === e.CourseYearId);
            if (found === undefined) {
                found = {
                    CourseYearId: e.CourseYearId,
                    CourseYearName: e.CourseYearName,
                    Divisions: []
                };

                console.log( this.curriculumSelected);
                console.log(this.shiftSelected);
                console.log(found);

                // filtrar por curriculum
                if(e.CurriculumId == this.curriculumSelected) {
                    if(this.shiftSelected == -1) {
                        this.divisionsGroup.push(found); 
                        found.Divisions.push(e);
                    } else if(e.ShiftId == this.shiftSelected) {
                        this.divisionsGroup.push(found);
                        found.Divisions.push(e);
                    }
                }
            } else {
                // filtrar por curriculum
                if(e.CurriculumId == this.curriculumSelected) {
                    if(this.shiftSelected == -1) {
                        found.Divisions.push(e);
                    } else if(e.ShiftId == this.shiftSelected) {
                        found.Divisions.push(e);
                    }
                }
                // found.Divisions.push(e);
            }
        });
        this.noDivisions = this.divisionsGroup.length === 0;
        console.log(this.divisionsGroup);
    }

    public planillaAlumnos(division) {
        if (division.CountStudents === 0) {
            this.sweetAlertService.info('Info', 'No hay alumnos en esta división', null);
        } else {
            window.open(environment.backendUri + 'report/studentslist/' + division.Id, '_parent');
        }
    }

    public planillaCalificaciones(division) {
        if (division.CountStudents === 0) {
            this.sweetAlertService.info('Info', 'No hay alumnos en esta división', null);
        } else {
            window.open(environment.backendUri + 'report/reportcard/' + division.Id, '_parent');
        }
    }

    goToStudents(Id) {
        this.router.navigate(['pages/management/students/' + Id]);
    }

    reloadData() {
        this.blockUIList.start('Cargando datos...');
        Observable.combineLatest(
            this.divisionService.getAllCountStudents(this.authenticationService.getAuthData().SchoolYear.Id, this.authenticationService.getAuthData().Id)
        ).subscribe(([divisions]) => {
            this.divisions = [];
            this.divisionsGroup = [];
            this.noDivisions = false;
            this.divisions = divisions;
            this.groupDivision();
            this.blockUIList.stop();
        });
    }


    filterShift(shiftId: number) {
        this.shiftSelected = shiftId;
        this.groupDivision();
    }

    filterCurriculum(curriculumId: number) {
        this.curriculumSelected = curriculumId;
        this.groupDivision();
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/home/home.component.ts